<template>
  <div class="todo-list">
    <h4 class="headline">MY TO DO LIST</h4>
    <ul>
      <li v-for="(item, index) in items" :key="item.id" :class="{completed: item.is_completed}">
        <a href="javascript:;" class="chk"  @click="toggleCompleted(index)"></a>
        <template v-if="index == editIndex">
          <form method="post" @submit.prevent="updateItem">
            <div class="form-group">
              <textarea class="form-control" ref="inputTitle" rows="3" placeholder="New item details..." v-model="editTitle"></textarea>
            </div>
            <button type="submit" class="btn btn-outline-black">Save</button>
            <button v-if="!isAdding" type="button" class="btn" @click="deleteItem(index)">Delete</button>
            <button type="button" class="btn" @click="cancelUpdate">Close</button>
          </form>
        </template>
        <template v-else>
          <label @dblclick="toggleEdit(index)">{{ item.title }}</label>
        </template>
      </li>
      <li class="no-items" v-if="items.length == 0">No items.</li>
    </ul>
    <button type="button" class="btn btn-outline-black" @click="addItem">+ Add Item</button>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import ServiceNote from '@/services/note'
export default {
  data () {
    return {
      editIndex: -1,
      editTitle: '',
      items: [],
      isAdding: false
    }
  },
  computed: {
    ...mapGetters(['CURRENT_USER'])
  },
  watch: {
    editIndex (newVal) {
      let self = this;
      self.editTitle = '';
      if ( newVal >= 0 ) {
        self.editTitle = self.items[newVal].title;
        // setTimeout(() => {
        //   self.$refs.inputTitle.focus();
        // }, 1000);
      }
    }
  },
  mounted () {
    this.init();
  },
  methods: {
    init () {
      let self = this;
      self.getItems();
    },
    toggleCompleted (index) {
      let self = this;
      if ( self.editIndex == index ) return;

      // update DB
      self.items[index].is_completed = !self.items[index].is_completed;
      ServiceNote.save(self.items[index].id, {is_completed: self.items[index].is_completed});
    },
    toggleEdit (index) {
      let self = this, item = self.items[index];
      if ( item.is_completed ) return;
      self.editIndex = index;
      self.isAdding = false;
    },
    addItem () {
      let self = this, totalItems = self.items.length;
      // add item to DB
      self.items.push({
        title: '',
        is_completed: false
      });
      self.editIndex = totalItems;
      self.isAdding = true;
    },
    _updateItem (updated_item) {
      let self = this, updatedData = {
        id: updated_item.id,
        title: updated_item.title,
        is_completed: updated_item.is_completed
      };

      if(self.isAdding){
        self.items.splice( self.editIndex, 1);
        self.items.unshift(updatedData);
        self.isAdding = false;
      }else{
        self.items.splice( self.editIndex, 1, updatedData);
      }
      self.editIndex = -1;
    },
    updateItem () {
      let self = this, item = self.items[self.editIndex];
      if ( self.editIndex < 0 ) return;

      // update DB
      if(self.isAdding) {
        ServiceNote.create({title: self.editTitle, type: 'todo'}, function(updated_item){
          self._updateItem(updated_item);
        });
      } else {
        ServiceNote.save(item.id, {title: self.editTitle}, function(updated_item){
          self._updateItem(updated_item);
        });
      }
    },
    cancelUpdate () {
      let self = this;
      if ( self.editIndex < 0 ) return;
      if(self.isAdding) {
        self.items.splice( self.editIndex, 1);
      }
      self.editIndex = -1;
    },
    deleteItem () {
      let self = this, item = self.items[self.editIndex];
      if ( self.editIndex < 0 || self.isAdding) return;
      self.$dialog
        .confirm('Are you sure you want to delete this todo item?', {
          html: true,
          loader: true,
          okText: "Yes, I'm sure",
          cancelText: "Cancel",
        })
        .then(dialog => {
          ServiceNote.delete(item.id, function(){
            dialog.close();
            self.items.splice(self.editIndex, 1);
            self.$notify({
              type: 'success',
              text: 'Todo item is deleted'
            });
            self.editIndex = -1;
          });
        })
        .catch(() => {})
      ;
    },
    getItems () {
      let self = this;
      self.state = 'loading';
      let params = {
        created_by: self.CURRENT_USER.id,
        type: 'todo',
        period: typeof self.CURRENT_USER.period_for_ticked_todo_items != 'undefined' ? self.CURRENT_USER.period_for_ticked_todo_items : '-1 week',
        ipp: 'all'
      };
      ServiceNote.getNotes(params, resp => {
        self.state = 'loaded';
        self.items = resp;
      });
    }
  }
}
</script>
